import React from 'react'
  const head = {
    heading:"Privacy Policy for Alumni",
    description:"Welcome to the privacy policy for the Alumni App. This policy outlines how we collect, use, and protect your personal information when you use our app."
  }
  const foot = {
    heading:"Contact Us for Alumni",
    description:"If you have any questions or concerns about this privacy policy or our data practices, please contact us at hemant@infoware.ws"
  }
  
  const Database = [
    {
      "id": 1,
      "title": "Information We Collect",
      "description": "Seamlessly connect alumni from various classes and locations with personalized profiles and messaging. Foster networking opportunities effortlessly with Alumni Connect.",
      "icon": "fa-solid fa-shield-halved",
      "options": [
        "Personal Information :  When you create an account, we collect personal information such as your name, email address, graduation year, and any additional details you choose to provide.",
        "Usage Information :  We may collect information about how you interact with the app, including pages visited, features used, and actions taken.",
        "Device Information :  We may collect information about your device, including device type, operating system, and unique device identifiers.",
        "Location Information : With your consent, we may collect and store your device's location information to provide location-based services, such as alumni event notifications."
        ],
      
    },
    {
      "id": 2,
      "title": "How We Use Your Information",
      "description": "We may use the information we collect for the following purposes:",
      "icon": "fa-solid fa-shield-halved",
      "options": [
        "To provide and maintain the functionality of the app.",
        "To personalize your experience and provide tailored content, such as alumni event recommendations.",
        "To communicate with you, including sending notifications and updates about the app or alumni-related news and events.",
        "To analyze usage trends and improve the performance and usability of the app.",
        "To comply with legal obligations or enforce our terms and policies.",
        ],
    },
    {
      "id": 3,
      "title": "Information Sharing",
      "description" :   "We may share your personal information with third parties in the following circumstances:",
      "icon": "fa-solid fa-shield-halved",
      "options": [
        "With your consent.",
        "With service providers who assist us in operating the app and providing related services, such as cloud hosting and analytics.",
        "In response to legal requests or to protect our rights or the rights of others.",
        "In connection with a merger, acquisition, or other business transaction involving the app."
        ],
    },
    {
      "id": 4,
      "title": "Data Security",
      "description": "We take reasonable measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.",
      "icon": "fa-solid fa-shield-halved"
    },
    {
      "id": 5,
      "title": "Data Retention",
      "description": "We will retain your personal information for as long as necessary to fulfill the purposes outlined in this privacy policy, unless a longer retention period is required or permitted by law",
      "icon": "fa-solid fa-shield-halved"
    },
    {
      "id": 6,
      "title": "Your Choices",
      "description": "You may choose not to provide certain personal information, but this may limit your ability to use certain features of the app. You can also update or delete your account information at any time by contacting us at hemant@infoware.ws",
      "icon": "fa-solid fa-shield-halved"
    },
    {
      "id": 7,
      "title": "Children's Privacy",
      "description": "The app is not intended for use by children under the age of 13. We do not knowingly collect personal information from children under 13. If you believe we have inadvertently collected such information, please contact us immediately.",
      "icon": "fa-solid fa-shield-halved"
    },
    {
      "id": 8,
      "title": "Changes to this Privacy Policy",
      "description": "We may update this privacy policy from time to time. Any changes will be posted to the app, and we encourage you to review the policy periodically. Your continued use of the app after the posting of changes constitutes acceptance of those changes.",
      "icon": "fa-solid fa-shield-halved"
    },
  ];
  console.log("Database" , Database);
const PrPolicy = () => {
  return (
    <div className="core_values" id="hospital" style={{marginTop:"20px"}}>
    <div className="container">
      <div className="comp_header">
        <h1>
         {head?.heading}
        </h1>
        <p>
          {head?.description}
        </p>
      </div>
      <div className="cards_wrapper">
        {Database?.map((data, idx) => (
          <div className="card">
            <div className="first">
              <i class={data?.icon}></i>
              <h3>{data?.title}</h3>
            </div>
            <div className="second">
              <p>
              {data?.description}
              </p>
            </div>
            <div className="pr-points">
              {data?.options?.map((dt) => (
                <p>
                  <i class="fa-solid fa-check"></i> {dt}
                </p>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="comp_header" style={{marginTop:"50px"}}>
        <h1>
         {foot?.heading}
        </h1>
        <p>
          {foot?.description}
        </p>
      </div>
    </div>
  </div>
  )
}

export default PrPolicy